type MoneyRoundingMode = 'HALF_EVEN' | 'HALF_UP';

export const MONEY_ROUNDING: MoneyRoundingMode = 'HALF_EVEN';

const isUpwardTie = (quotient: bigint, mode: MoneyRoundingMode): boolean =>
    mode === 'HALF_UP' || quotient % 2n !== 0n;

/** Divides by a positive denominator, rounding to the nearest integer by MONEY_ROUNDING
 *  with ties resolved symmetrically about zero. */
export const roundMoneyDiv = (numerator: bigint, denominator: bigint): bigint => {
    const negative = numerator < 0n;
    const magnitude = negative ? -numerator : numerator;
    const quotient = magnitude / denominator;
    const twiceRemainder = (magnitude - quotient * denominator) * 2n;
    const roundsUp = twiceRemainder > denominator
        || (twiceRemainder === denominator && isUpwardTie(quotient, MONEY_ROUNDING));
    const rounded = roundsUp ? quotient + 1n : quotient;
    return negative ? -rounded : rounded;
};
